<template>
  <div class="testList">
    <div class="add">
      <el-button
        type="primary"
        size="medium"
        @click="realNameAuthen"
        :disabled="false"
        >实名认证</el-button
      >
      <el-button
        v-if="applyCerButShow"
        type="primary"
        size="medium"
        @click="applyCer"
        :disabled="false"
        >申请实名证书
      </el-button>
      <el-button
        type="primary"
        size="medium"
        @click="applicationCer"
        :disabled="false"
        >印章</el-button
      >
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        label="序号"
        type="index"
        :index="getIndex"
        width="60px"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="test_class_title"
        label="合同编号"
        align="center"
        width="120px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.contract_id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="test_class_title"
        label="订单编号"
        align="center"
        width="200px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.order_sn }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="test_grade" label="合同名称" align="center">
        <template slot-scope="scope">
          <span>
            <a :href="scope.row.viewpdf_url">{{ scope.row.doc_title }}</a></span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="registration_start_time"
        label="签署时间"
        align="center"
        width="100px"
      >
        <template slot-scope="scope">{{ scope.row.timestamp }} </template>
      </el-table-column>
      <el-table-column
        prop="test_start_time"
        label="状态"
        align="center"
        width="100px"
      >
        <template slot-scope="scope">
          <span
            class="spanVa"
            v-if="
              scope.row.contract_status == 1 && scope.row.payment_status == 0
            "
            @click="toPay(scope.row)"
            >{{ scope.row.result_code_view }}</span
          >
          <span v-else>{{ scope.row.result_code_view }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="test_detail_addr"
        label="操作"
        align="center"
        width="170px"
      >
        <template slot-scope="scope">
          <!-- <button>签署</button><button>下载{{scope.row.result_code_view}}</button> -->
          <a href="javascript:void(0);" @click="signCon(scope.row)">签署</a
          >&nbsp;&nbsp;<a :href="scope.row.download_url" target="_blank"
            >下载</a
          >
          <!-- paystatus -->

          &nbsp;&nbsp;<a
            v-if="scope.row.paystatus"
            :href="scope.row.imgUrl"
            target="_blank"
            >收据</a
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="二维码支付"
      :visible.sync="paydialog"
      :width="screenWidth > 768 ? '40%' : '90%'"
      center
      :close-on-click-modal="false"
    >
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img" />
        <div>仅支持微信扫码支付</div>
      </div>
    </el-dialog>
    <div class="pagination" style="margin-top: 20px; text-align: center">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        v-if="totalCount > 8"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetTestApplyList,
  GetUserTestMechanismDetail,
  GetApplycert,
  GetContractList,
  GetExtsign,
} from "@/api/admin/test.js";
import { GDCloudPayV2, GetPaymentStatus } from "@/api/admin/common.js";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["screenWidth"]),
  },
  data() {
    return {
      tableData: [],
      paging: {
        limit: 8,
        page: 1,
      },
      formData: {},
      payview: false,
      paydialog: false,
      applyCerButShow: true,
      imgPath: window.apiObj.apiUrl,
      paystatus: false,
      sn: null,
      totalCount: 0,
    };
  },
  created() {
    this.getApplycert();
    this.getList();
    this.intervalPay();
    this.paytime = setInterval(() => {
      this.intervalPay();
    }, 10000);
  },
  methods: {
    intervalPay() {
      if (this.payview) {
        if (this.sn != null) {
          GetPaymentStatus({ order_sn: this.sn }).then((data) => {
            if (data.data.result.orderStatus == 3) {
              this.$message({
                message: "支付完成",
                type: "success",
              });
              this.paydialog = false;
              this.payview = false;
              this.sn = null;
              this.getList();
            }
          });
        }
      }
    },

    toPay(row) {
      this.sn = row.order_sn;
      GDCloudPayV2({ order_sn: this.sn }).then((data) => {
        if (data.data.result.isSuccess) {
          this.paydialog = true;
          this.payview = true;
          this.formData.img = this.imgPath + data.data.result.payCode;
        } else {
          this.$message({
            message: data.data.result.errorMsg,
            type: "error",
          });
        }
      });
    },
    signCon(params) {
      var dataVal = { contract_id: params.contract_id }; //{ classCode: "certificate_grade" };
      GetExtsign(dataVal).then((data) => {
        var dataResult = data.data.result;

        window.open(dataResult, "_blank");
        /*
        if (dataResult.isSuccess==true) {
           var seriaNo = dataResult.testMechanismResult.seriaNo;
           if(seriaNo !=null ){
                this.applyCerButShow = false;
           }
        }
        */
      });
    },
    getApplycert() {
      var dataVal = {}; //{ classCode: "certificate_grade" };
      GetUserTestMechanismDetail(dataVal).then((data) => {
        var dataResult = data.data.result;

        if (dataResult.isSuccess == true) {
          var seriaNo = dataResult.testMechanismResult.seriaNo;
          if (seriaNo != null) {
            this.applyCerButShow = true;
          }
        }
      });
    },
    // 表格索引
    getIndex(index) {
      let curpage = this.paging.page; //当前页码
      let limitpage = this.paging.limit; //每页条数
      return index + 1 + (curpage - 1) * limitpage;
    },
    getList() {
      var parData = {
        limit: 10,
        page: this.paging,
      };
      GetContractList(Object.assign(this.paging)).then((data) => {
        var list = data.data.result;

        if (list) {
          this.tableData = list.items;

          this.totalCount = list.totalCount;
          this.doList();
        }
      });
    },
    formatDate(row) {
      let moment = require("moment");
      return moment(row.creationTime).format("YYYY-MM-DD HH:mm:ss");
    },
    handleClick(row) {
      this.$router.push({
        path: "/personal/testList/viewEntry",
        query: {
          id: row.id,
          application_status: row.application_status,
        },
      });
    },
    //实名认证   realNameAuthen   applicationCer
    realNameAuthen() {
      this.$router.push({ path: "/personal/realNameAuthentication" });
    },
    //申请证书
    applicationCer() {
      this.$router.push({ path: "/personal/applicationCertificate" });
    },
    //实名证书申请
    applyCer() {
      var dataVal = {}; //{ classCode: "certificate_grade" };
      /*
      Applycert(dataVal).then(data => {
        var dataResult = data.data.result;

      });*/
      GetApplycert(dataVal).then((data) => {
        var dataResult = data.data.result;

        if (dataResult.code == 1 || dataResult.code == "1") {
          alert("申请成功");
        } else {
          alert("申请失败，请重新实名认证");
        }
      });
    },

    /*
    2020年10月26日 10:49:54
    XXL
    改变列表数据格式
    */
    doList() {
      for (var i = 0; i < this.tableData.length; i++) {
        var aaa = this.tableData[i].timestamp;
        if (aaa) {
          this.tableData[i].timestamp =
            aaa.substring(0, 4) +
            "-" +
            aaa.substring(4, 6) +
            "-" +
            aaa.substring(6, 8);
        }

        // payment_status 1已付款；0未付款
        if (this.tableData[i].result_code == "0") {
          this.tableData[i].result_code_view = "签署中";
          this.tableData[i].paystatus = false;
        } else if (this.tableData[i].result_code == "3000") {
          this.tableData[i].result_code_view = "签署成功";
          this.tableData[i].paystatus = false;
        } else if (this.tableData[i].result_code == "3001") {
          this.tableData[i].result_code_view = "签署失败";
          this.tableData[i].paystatus = false;
        }
        if (
          this.tableData[i].contract_status == "1" ||
          this.tableData[i].contract_status == 1
        ) {
          if (this.tableData[i].payment_status == 1) {
            this.tableData[i].result_code_view = "支付成功";
            this.tableData[i].paystatus = true;
            this.tableData[i].imgUrl =
              this.imgPath +
              "/files/baozhengjin/" +
              this.tableData[i].deposit1 +
              ".jpg";
          } else {
            this.tableData[i].result_code_view = "待支付";
            this.tableData[i].paystatus = false;
          }
        }
      }
    },
    // 分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      GetContractList(Object.assign(this.paging)).then((data) => {
        var list = data.data.result;
        if (list) {
          this.tableData = list.items;
          this.doList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.testList {
  .add {
    margin-bottom: 10px;
  }
}

.spanVa {
  color: #409eff;
  cursor: pointer;
}

.paystyle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  color: #ea0000;
}
</style>
